import { isNil } from "lodash-es";
import ApiClientError from "./ApiClientError";

class NotFoundError extends ApiClientError {
  static create: $TSFixMe;

  /* istanbul ignore next */
  constructor(request: $TSFixMe, response: $TSFixMe, cause: $TSFixMe) {
    super(
      "NotFoundError",
      404,
      "The resource or the specified URL could not be found or the requesting user has no permission.",
      request,
      response,
      cause,
    );

    if (this.response && this.response.data) {
      this.errors = this.response.data.errors;
    }
  }

  contains = (type: $TSFixMe, attribute = null) => {
    if (attribute) {
      return (
        !isNil(this.errors) &&
        !isNil(
          this.errors.find(
            (error: $TSFixMe) =>
              error.type === type && error.attribute === attribute,
          ),
        )
      );
    }
    return (
      !isNil(this.errors) &&
      !isNil(this.errors.find((error: $TSFixMe) => error.type === type))
    );
  };
}

NotFoundError.create = (errors: $TSFixMe) =>
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
  new NotFoundError(null, { data: { errors } });

export default NotFoundError;
